module.exports = __webpack_public_path__ + "static/media/infoPin.f1b4aca5.png";